// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import { useLoading } from "../utils/loading/LoadingContext";
// import "./styles/scantool.css"; // Make sure the path is correct
// import success from "../assets/images/check.png";
// import not_found from "../assets/images/cross.png";
// import invalid_format from "../assets/images/warning.png";
// import already_processed from "../assets/images/exist.png";
// import no_status from "../assets/images/no_status.png";

// const statusImages = {
//   success: success,
//   not_found: not_found,
//   invalid_format: invalid_format,
//   already_processed: already_processed,
//   no_status: no_status,
// };

// const ScanTool = () => {
//   const [identifier, setIdentifier] = useState("");
//   const { setLoading } = useLoading();
//   const inputRef = useRef(null);
//   const formatDate = (dateString) => {
//     // const options = {  month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', timeZoneName: 'short' };
//     const options = {  month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'};

//     const date = new Date(dateString);
//     return date.toLocaleDateString("en-US", options);
//   };

//   const baseUrl = process.env.REACT_APP_DJANGO_API_BASE_URL

//   const [successfulBOLs, setSuccessfulBOLs] = useState(() => {
//     // Get successful BOLs from local storage or initialize to an empty array
//     const savedBOLs = localStorage.getItem("successfulBOLs");
//     return savedBOLs ? JSON.parse(savedBOLs) : [];
//   });

//   const [results, setResults] = useState({
//     processedBols: [],
//     lastBolStatus: "",
//     messages: [],
//     scanned_date:"",
//     scanned_by: '',
//     total_units:''
//   });
//   const handleInputChange = (e) => {
//     const inputWithoutSpaces = e.target.value.replace(/\s+/g, '');
//     setIdentifier(inputWithoutSpaces);

//   };
//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     const token = localStorage.getItem("token");

//     const config = {
//       headers: {
//         Authorization: `Token ${token}`, // Ensure you use the correct token prefix; 'Token' is common for DRF TokenAuthentication
//       },
//     };

//     setLoading(true);
//     try {
//       const response = await axios.post(
//         `${baseUrl}/api/scan-tool/`,
//         { identifier },
//         config
//       );
//       setResults({
//         processedBols: response.data.processed_bols,
//         lastBolStatus: response.data.last_bol_status,
//         messages: response.data.messages,
//         scanned_date: response.data.scanned_date,
//         scanned_by: response.data.scanned_by,
//         total_units: response.data.total_units
//       });
//       if (response.data.last_bol_status === "success") {
//         const updatedBOLs = [...successfulBOLs, {
//           identifier: identifier,
//           scanned_date: response.data.scanned_date,
//           scanned_by: response.data.scanned_by,
//           total_units: response.data.total_units
//         }];
//         setSuccessfulBOLs(updatedBOLs);
//         localStorage.setItem("successfulBOLs", JSON.stringify(updatedBOLs));
//       }
//       console.log(response.data.messages);
//     } catch (error) {
//       console.error("Error fetching data: ", error);
//       // Handle errors here if needed
//     }

//     setLoading(false);
//     setIdentifier("");
//     inputRef.current.focus();

//     console.log(results);
//   };
//   useEffect(() => {
//     inputRef.current.focus();
//   }, []);
//   return (
//     <div className="whole-container">
//       <div className="scan-container">
//         <h1>Scan Tool</h1>
//         <form className="scan-form" onSubmit={handleSubmit}>
//           <input
//             type="text"
//             className="large-input" // Applied large-input class for styling
//             value={identifier}
//             onChange={handleInputChange}
//             placeholder="Scan..."
//             ref={inputRef}

//           />
//           <button type="submit">Submit</button>
//         </form>
//       </div>
//       {
//     results.messages && results.messages.length > 0 ? (
//         <div className={`message ${results.lastBolStatus}`}>
//             <div>
//                 <img className="status-image" src={statusImages[results.lastBolStatus]} />
//             </div>
//             {results.messages.map((message, index) => (
//                 <div key={index} className={`message ${message.type}`}>
//                     <p>{message}</p> {/* Fallback to "Scan" if message is null or empty */}
//                 </div>
//             ))}
//         </div>
//     ) : (
//         <div className="message no_status">
//             <div>
//                 <img className="status-image" src={no_status} />
//             </div>
//             <div className="message no_status">
//                     <p>Let's Start!</p> {/* Fallback to "Scan" if message is null or empty */}
//                 </div>
//         </div>
//     )
// }

//       <div className="table-container">
//         {successfulBOLs.length > 0 && (
//           <div>
//             <h2>Recent BOLs</h2>
//             <table>
//           <thead>
//             <tr>
//               <th>Scanned By</th>
//               <th>BOL / PkgID</th>
//               <th>Total Units</th>
//               <th>Date</th>
//             </tr>
//           </thead>
//           <tbody>
//             {[...successfulBOLs].reverse().map((bol, index) => (
//               <tr key={index}>
//                 <td>{bol.scanned_by}</td>
//                 <td>{bol.identifier}</td>
//                 <td>{bol.total_units}</td>
//                 <td>{formatDate(bol.scanned_date)}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ScanTool;
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useLoading } from "../utils/loading/LoadingContext";
import "./styles/scantool.css"; // Make sure the path is correct
import success from "../assets/images/check.png";
import not_found from "../assets/images/cross.png";
import invalid_format from "../assets/images/warning.png";
import already_processed from "../assets/images/exist.png";
import no_status from "../assets/images/no_status.png";
import high_value from "../assets/images/high_value.png";

// Import audio files
import successAudio from "../assets/audios/success.mp3";
import highValueAudio from "../assets/audios/high_value.mp3";
import alreadyProcessedAudio from "../assets/audios/exist.mp3";
import invalidFormatAudio from "../assets/audios/error.mp3";
import notFoundAudio from "../assets/audios/error.mp3";

// Map status to images
const statusImages = {
  success: success,
  not_found: not_found,
  invalid_format: invalid_format,
  already_processed: already_processed,
  no_status: no_status,
  high_value: high_value,
};

// Map status to audio elements
const statusAudios = {
  success: successAudio,
  high_value: highValueAudio,
  already_processed: alreadyProcessedAudio,
  invalid_format: invalidFormatAudio,
  not_found: notFoundAudio,
};

const ScanTool = () => {
  const [identifier, setIdentifier] = useState("");
  const { setLoading } = useLoading();
  const inputRef = useRef(null);

  const formatDate = (dateString) => {
    const options = {
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", options);
  };

  const baseUrl = process.env.REACT_APP_DJANGO_API_BASE_URL;

  const [successfulBOLs, setSuccessfulBOLs] = useState(() => {
    const savedBOLs = localStorage.getItem("successfulBOLs");
    return savedBOLs ? JSON.parse(savedBOLs) : [];
  });

  const [results, setResults] = useState({
    processedBols: [],
    lastBolStatus: "",
    messages: [],
    scanned_date: "",
    scanned_by: "",
    total_units: "",
  });

  const handleInputChange = (e) => {
    const inputWithoutSpaces = e.target.value.replace(/\s+/g, "");
    setIdentifier(inputWithoutSpaces);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const token = localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };

    setLoading(true);
    try {
      const response = await axios.post(
        `${baseUrl}/api/scan-tool/`,
        { identifier },
        config
      );
      setResults({
        processedBols: response.data.processed_bols,
        lastBolStatus: response.data.last_bol_status,
        messages: response.data.messages,
        scanned_date: response.data.scanned_date,
        scanned_by: response.data.scanned_by,
        total_units: response.data.total_units,
      });

      // Play audio corresponding to the status
      const audioSrc = statusAudios[response.data.last_bol_status];
      if (audioSrc) {
        const audioElement = new Audio(audioSrc);
        audioElement.play();
      }

      if (response.data.last_bol_status === "success" ||
        response.data.last_bol_status === "high_value") {
        const updatedBOLs = [
          ...successfulBOLs,
          {
            identifier: identifier,
            scanned_date: response.data.scanned_date,
            scanned_by: response.data.scanned_by,
            total_units: response.data.total_units,
          },
        ];
        setSuccessfulBOLs(updatedBOLs);
        localStorage.setItem("successfulBOLs", JSON.stringify(updatedBOLs));
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
    }

    setLoading(false);
    setIdentifier("");
    inputRef.current.focus();
  };

  // Focus the input when component mounts
  useEffect(() => {
    inputRef.current.focus();
  }, []);

  return (
    <div className="whole-container">
      <div className="scan-container">
        <h1>Scan Tool</h1>
        <form className="scan-form" onSubmit={handleSubmit}>
          <input
            type="text"
            className="large-input" // Applied large-input class for styling
            value={identifier}
            onChange={handleInputChange}
            placeholder="Scan..."
            ref={inputRef}
          />
          <button type="submit">Submit</button>
        </form>
      </div>

      {results.messages.length > 0 ? (
        <div className={`message ${results.lastBolStatus}`}>
          <div>
            <img
              className="status-image"
              src={statusImages[results.lastBolStatus]}
              alt="Status Icon"
            />
          </div>
          {results.messages.map((message, index) => (
            <div key={index} className={`message ${message.type}`}>
              <p>{message}</p>
            </div>
          ))}
        </div>
      ) : (
        <div className="message no_status">
          <div>
            <img className="status-image" src={no_status} alt="No Status" />
          </div>
          <div className="message no_status">
            <p>Let's Start!</p>
          </div>
        </div>
      )}

      <div className="table-container">
        {successfulBOLs.length > 0 && (
          <div>
            <h2>Recent BOLs</h2>
            <table>
              <thead>
                <tr>
                  <th>Scanned By</th>
                  <th>BOL / PkgID</th>
                  <th>Total Units</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {[...successfulBOLs].reverse().map((bol, index) => (
                  <tr key={index}>
                    <td>{bol.scanned_by}</td>
                    <td>{bol.identifier}</td>
                    <td>{bol.total_units}</td>
                    <td>{formatDate(bol.scanned_date)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default ScanTool;
